import React, { useRef, useEffect } from "react";
import "./Tooltip.css";
import { Icon } from "@msi/cobalt-react";

interface TooltipProps {
    title: string;
    placement?: "top" | "bottom" | "left" | "right";
    className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
    title,
    placement = "top",
    className = "",
}) => {
    const spanRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        // Capture element reference before cleanup closure
        const element = spanRef.current;
        
        // @ts-ignore
        if (window.bootstrap && element) {
            // Dispose existing tooltip if any
            // @ts-ignore
            const existing = window.bootstrap.Tooltip.getInstance(element);
            if (existing) existing.dispose();
            
            // Create new tooltip
            // @ts-ignore
            new window.bootstrap.Tooltip(element);
        }

        return () => {
            // Use captured element, not ref (which may be null after unmount)
            if (element) {
                // @ts-ignore
                const instance = window.bootstrap?.Tooltip.getInstance(element);
                if (instance) instance.dispose();
            }
        };
    }, [title, placement]);

    return (
        <span
            ref={spanRef}
            data-bs-toggle="tooltip"
            data-bs-placement={placement}
            data-bs-custom-class="custom-tooltip"
            data-bs-title={title}
            className={`input-group-text bg-white info-icon ${className} tooltip-icon`}
            tabIndex={0}
            style={{ cursor: "pointer" }}
        >
            <Icon
                name="ic_information"
                size={18}
                color="#777"
                className="msi-icon"
            />
        </span>
    );
}
export default Tooltip;